export default [
  'The play() request was interrupted',
  'The operation was aborted',
  'The fetching process for the media resource was aborted by the user agent',
  'The request is not allowed by the user agent or the platform in the current context',
]
